import { render } from "./ReceiveTransfer.vue?vue&type=template&id=0ac41595&scoped=true"
import script from "./ReceiveTransfer.vue?vue&type=script&lang=js"
export * from "./ReceiveTransfer.vue?vue&type=script&lang=js"

import "./ReceiveTransfer.vue?vue&type=style&index=0&id=0ac41595&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/jb/jb-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ac41595"]])

export default __exports__